module.exports = __webpack_public_path__ + "static/media/olive.91d032d2.png";